import { useQuery } from "@tanstack/react-query"
import { Calendar, Users, DollarSign } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { StatsCard } from "@/components/dashboard/StatsCard"
import { UpcomingEventsTable } from "@/components/dashboard/UpcomingEventsTable"
import { getHostDashboardStats } from "@/lib/queries/host"

export default function HostDashboardOverview({ profile, session }: { profile: any | null, session: any | null }) {
  const { data: stats } = useQuery({
    queryKey: ["host-dashboard-stats", profile?.id],
    queryFn: () => getHostDashboardStats(session?.access_token!),
    enabled: !!profile?.id && !!session?.access_token,
  })

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h2 className="text-4xl font-bold tracking-tight">Overview</h2>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatsCard
          title="Total Events"
          value={stats?.totalEvents || 0}
          icon={Calendar}
        />
        <StatsCard
          title="Total Participants"
          value={stats?.totalParticipants || 0}
          icon={Users}
        />
        <StatsCard
          title="Total Revenue"
          value={stats?.totalRevenue || 0}
          icon={DollarSign}
          valuePrefix="₹"
        />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Upcoming Events</CardTitle>
        </CardHeader>
        <CardContent>
          <UpcomingEventsTable events={stats?.upcomingEventsList || []} />
        </CardContent>
      </Card>
    </div>
  )
}